export default __webpack_public_path__ + "static/ay-glossary-knowledge-desk-filter-small-icon-398c034e7a28807c279a7f2d61b146d0.svg";